/**
 * @deprecated
 */
export { default as getInputProp } from './getInputProp';
